import { __assign, __rest } from "tslib";
import React from 'react';
import { StyledLink } from './Link.styled';
var Link = function (_a) {
    var external = _a.external, props = __rest(_a, ["external"]);
    return (React.createElement(StyledLink, __assign({}, props, (external ? { target: '_blank', rel: 'noopener noreferrer' } : {}), { component: props.component || 'a' })));
};
export { Link };
//# sourceMappingURL=Link.js.map